import { useContext, useEffect, useState } from "react";
//import { useHistory } from "react-router-dom";

// Components
import { Conferences } from "./Conferences";

// Context
import { ConferencesContext } from "../../context/conferences";
import { VideosContext } from "../../context/videos";

// Platforms
import { Api } from "../../platforms/api";

// Utils
import { reformatAcfResponse } from "../../utils/fetchUtils";

export const ConferencesContainer = (props) => {
    const {
        hasRedirectedToFeaturedConference,
        setHasRedirectedToFeaturedConference,
    } = props;

    /**
     * Router Hooks
     */

    //const history = useHistory();

    /**
     * useContext
     */

    const { conferences, featuredConference, isLoadingConferences } =
        useContext(ConferencesContext);
    const { videos } = useContext(VideosContext);

    /**
     * useState
     */

    const [blocks, setBlocks] = useState(null);
    const [loading, setLoading] = useState({ blocks: true, conferences: true });

    /**
     * useEffect
     */

    useEffect(() => {
        fetchBlocks();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (featuredConference && !hasRedirectedToFeaturedConference) {
            //history.push(`/conferences/${featuredConference.slug}`);
            //setHasRedirectedToFeaturedConference(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [featuredConference]);

    useEffect(() => {
        setLoading((prev) => ({ ...prev, conferences: isLoadingConferences }));
    }, [isLoadingConferences]);

    /**
     * End Hooks
     */

    function fetchBlocks() {
        Api.getBlocks(onFetchBlocksSuccess, onFetchBlocksError);
    }

    function onFetchBlocksError(err) {
        setLoading((prev) => ({ ...prev, blocks: false }));
    }

    function onFetchBlocksSuccess({ body: res, headers }) {
        const formattedResponse = reformatAcfResponse(res);
        setBlocks(formattedResponse[0].block);
        setLoading((prev) => ({ ...prev, blocks: false }));
    }

    return (
        <Conferences
            {...props}
            blocks={blocks}
            conferences={conferences}
            loading={loading}
            videos={videos}
        />
    );
};
